module.exports = __webpack_public_path__ + "img/takeLeave_3_en.5cd60b2c.png";